// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"fdb83af6","283":"73ec8e02","406":"af631621","423":"bfe505d0","496":"73f35b80"}[chunkId] + ".chunk.js";
};